import { menuID } from "../../TypesAndConstants/const";
const menuIDS = Object.values(menuID);

export const isSketchActive = () => {
  let isActive = true;
  if( document.querySelector(".MuiDialog-root") != null ){
    isActive =  false;
  } 
  if( isActive ) {
    document.querySelectorAll(":hover").forEach(i => {
      if (menuIDS.includes(i.id)) {
        isActive = false;
      }
    });
  }
  return isActive;
};
